/**
 * Hide/Show a given HTML element
 * @param {HTMLElement} element 
 * @param {boolean} doShow 
 * @param {string} displayType a string representing a CSS 'display' property e.g. 'none', 'block', 'flex'
 * @returns {void}
 */
const toggle = (element, doShow, displayType = "block") => {
    if (!element || !(element instanceof Element)) {
        // console.warn('No valid element passed');
        return;
    }
    element.style.display = doShow ? displayType : "none";
}

/**
 * Removes trailing zeroes from strings representing round/non-fractional figures
 * @param {*} priceStr 
 * @returns 
 */
const formatPriceString = (priceStr) => {
    // console.log(typeof price);
    return typeof priceStr == "string" && priceStr.endsWith('.00') 
        ? priceStr.slice(0, -3) 
        : priceStr;
}


/**
 * Used to hide and show extras and party members depending on the parentId
 * 
 * @param string sectionSelector - ID/Class 
 * @param string optionSelector 
 * @param number parentId 
 */
const showOptionsWithParentId = (sectionSelector, optionSelector, parentId) => {
    const section = document.querySelector(sectionSelector);
    if (!section) return 0;

    // Find all options inside the section
    const options = section.querySelectorAll(optionSelector);

    // Hide all by default
    options.forEach(option => option.classList.add('d-none'));

    // Filter for options that contain parentId inside their data-parents attribute
    const filtered = filterElementsByParentId([...options], parentId);

    // Show the filtered ones
    filtered.forEach(option => option.classList.remove('d-none'));

    // Remove border separator from last element
    if (filtered.length > 0) {
        filtered[filtered.length - 1].classList.remove('separator');
    }

    // Show the section
    section.style.display = "";
}

/**
 * Filters elements by a parent ID 
 * @param {*} elementArray 
 * @param {number} parentId 
 * @returns {Array} - an array of filtered elements
 */
const filterElementsByParentId = (elementArray, parentId = -1) => {
    if (parentId < 0) {
        console.error('No parentId passed to function');
        return;
    }

    return elementArray.filter(option => {
        const parents = option.dataset.parents || "";
        return parents.includes(parentId);
    });
}

const toggleDiscountTagFromContainers = (discountCode = "", display) => {
    document.querySelectorAll('.atb-discount-tag').forEach(tagElement => {
        if (discountCode === tagElement.getAttribute('data-discount-code')) {
            if (display) {
                tagElement.style.display = 'inline-flex';
            } else {
                tagElement.style.display = 'none';
            }
        }
    });
}

/**
 * Announces a message to screen reader users via the shared aria-live region
 * (#atb-a11y-announcer), for content that appears/changes without a focus change
 * @param {string} message
 */
const announce = (message) => {
    const region = document.getElementById('atb-a11y-announcer');
    if (!region) return;

    // Clear first so the same message said twice in a row still gets announced
    region.textContent = '';
    requestAnimationFrame(() => {
        region.textContent = message;
    });
}

export {
    toggle,
    filterElementsByParentId,
    formatPriceString,
    showOptionsWithParentId,
    toggleDiscountTagFromContainers,
    announce
}